import { FC } from 'react';

import { MyNodeModel } from '../../hooks/useDragAndDrop';
import s from './styles.module.scss';

type PlaceholderProps = {
  node: MyNodeModel;
  depth: number;
};

export const Placeholder: FC<PlaceholderProps> = (props) => {
  const left = props.depth * 24;
  return <div className={s.placeholderRoot} style={{ left }}></div>;
};
